import useTheme from 'threads5/styles/useTheme';

export const useIsDarkMode = () => {
  const theme = useTheme();
  return theme.palette.mode === 'dark';
};
